<template>
    <!-- Gráfico de columnas: una por categoría (meses, horas, días). Las
         columnas en cero se dibujan igual para que la escala sea uniforme.
         El valor exacto aparece al pasar el mouse o con el teclado. -->
    <div>
        <div class="es-cols" :style="{ '--alto': alto + 'px' }" role="list" :aria-label="titulo">
            <div v-for="(it, i) in items" :key="it.k" class="es-col" :class="{ 'is-max': esMax(it), 'is-cero': !it.n }" :style="{ '--h': h(it) }"
                 role="listitem" tabindex="0" :aria-label="textoTip(it)" @mouseenter="sobre = i" @mouseleave="sobre = null" @focus="sobre = i" @blur="sobre = null">
                <span v-if="valores && it.n" class="es-col-v" aria-hidden="true">{{ cifra(it.n) }}</span>
                <span class="es-col-b" :style="{ height: h(it) }"></span>
                <span v-if="sobre === i" class="es-tip" role="tooltip"><b>{{ cifra(it.n) }} {{ it.n === 1 ? unidad[0] : unidad[1] }}</b>{{ it.tip || it.t }}<template v-if="it.pct !== undefined"> · {{ fmtPct(it.pct) }}</template></span>
            </div>
        </div>
        <div class="es-cols-x" aria-hidden="true">
            <span v-for="(it, i) in items" :key="it.k" :class="{ 'is-max': esMax(it) }">{{ cada > 1 && i % cada ? '' : it.t }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EstColumnas',
    props: {
        items: { type: Array, default: () => [] },
        titulo: { type: String, default: '' },
        alto: { type: Number, default: 220 },
        cada: { type: Number, default: 1 },
        valores: { type: Boolean, default: true },
        unidad: { type: Array, default: () => ['intake', 'intakes'] },
    },
    data() { return { sobre: null }; },
    computed: { max() { return Math.max(0, ...this.items.map(i => i.n)); } },
    methods: {
        cifra(n) { return Number(n || 0).toLocaleString('es-CL'); },
        fmtPct(p) { return Number(p || 0).toLocaleString('es-CL', { maximumFractionDigits: 1 }) + '%'; },
        esMax(it) { return this.max > 0 && it.n === this.max; },
        h(it) { return this.max ? Math.max(it.n ? 3 : 1, Math.round(it.n * 100 / this.max)) + '%' : '1%'; },
        textoTip(it) { return `${it.tip || it.t}: ${this.cifra(it.n)} ${it.n === 1 ? this.unidad[0] : this.unidad[1]}${it.pct !== undefined ? ' (' + this.fmtPct(it.pct) + ')' : ''}`; },
    },
};
</script>
